import { Operator } from './types';

export const basicOperators: Operator[] = [
    {
        name: 'exist',
        label: '',
        requiredOperands: 1,
    },
    {
        name: 'notexist',
        label: '',
        requiredOperands: 1,
    },
];

export const numberOperators: Operator[] = [
    {
        name: 'number:equal',
        label: '',
    },
    {
        name: 'number:notequal',
        label: '',
    },
    {
        name: 'number:less',
        label: '',
    },
    {
        name: 'number:lessorequal',
        label: '',
    },
    {
        name: 'number:greater',
        label: '',
    },
    {
        name: 'number:greaterorequal',
        label: '',
    },
];

export const textOperators: Operator[] = [
    {
        name: 'text:equal',
        label: '',
    },
    {
        name: 'text:equal:ci',
        label: '',
    },
    {
        name: 'text:notequal',
        label: '',
    },
    {
        name: 'text:notequal:ci',
        label: '',
    },
    {
        name: 'text:contain',
        label: '',
    },
    {
        name: 'text:contain:ci',
        label: '',
    },
    {
        name: 'text:notcontain',
        label: '',
    },
    {
        name: 'text:notcontain:ci',
        label: '',
    },
    {
        name: 'text:startwith',
        label: '',
    },
    {
        name: 'text:startwith:ci',
        label: '',
    },
    {
        name: 'text:endwith',
        label: '',
    },
    {
        name: 'text:endwith:ci',
        label: '',
    },
    {
        name: 'text:notendwith',
        label: '',
    },
    {
        name: 'text:notendwith:ci',
        label: '',
    },
];

export const booleanOperators: Operator[] = [
    {
        name: 'boolean:equal',
        label: '',
    },
    {
        name: 'boolean:notequal',
        label: '',
    },
];
